import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, RotateCcw } from "lucide-react";
import { bgWithImageStyle } from "../utils/themeBg";

export default function CheckoutCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen text-white flex items-center justify-center px-4" style={bgWithImageStyle()} data-testid="checkout-cancel-page">
      <div className="w-full max-w-lg text-center">
        <div className="mx-auto w-20 h-20 mb-8 flex items-center justify-center rounded-full bg-amber-500/15 border border-amber-400/40">
          <XCircle className="w-10 h-10 text-amber-300" strokeWidth={1.5} />
        </div>
        <span className="text-[10px] tracking-[0.4em] uppercase text-[#C0C0C0]">LEOVERA Nutrition</span>
        <h1 className="mt-3 font-[Outfit] text-4xl sm:text-5xl font-light tracking-tight">Pagamento annullato</h1>
        <p className="mt-4 text-[#94A3B8] text-sm leading-relaxed">
          Il pagamento è stato annullato e non ti è stato addebitato nulla. Il tuo carrello è ancora disponibile:
          puoi riprovare quando vuoi.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button onClick={() => navigate("/checkout")} data-testid="checkout-cancel-retry"
                  className="inline-flex items-center justify-center gap-3 bg-[#C0C0C0] text-[#060A14] px-8 py-4 rounded-sm text-[11px] tracking-[0.28em] uppercase font-medium hover:bg-white transition-colors">
            <RotateCcw className="w-4 h-4" /> Riprova il pagamento
          </button>
          <Link to="/" data-testid="checkout-cancel-shop"
                className="inline-flex items-center justify-center gap-2 border border-white/15 text-[#E5E4E2] px-8 py-4 rounded-sm text-[11px] tracking-[0.24em] uppercase hover:bg-white/5 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Torna allo Shop
          </Link>
        </div>
      </div>
    </div>
  );
}
